import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Plus } from 'lucide-react';
import BatchQueryModal from '@/temu-platform/modules/products/components/BatchQueryModal';
import {
  joinBatchTokens,
  BATCH_QUERY_LIMIT,
} from '@/temu-platform/modules/products/components/batchQueryUtils';

/**
 * 模板库款号批量查询：标签 + 输入（逗号批量）+「+」弹窗，交互对齐商品列表货号筛选。
 */
export default function TemuStyleNoBatchFilter({
  value = '',
  disabled = false,
  onChange,
  onEnter,
  className = '',
}) {
  const { t } = useTranslation('workbench');
  const [batchOpen, setBatchOpen] = useState(false);

  return (
    <>
      <div className={['tpo-field tpo-field--inline tpo-field--batch tpo-field--style-no', className].filter(Boolean).join(' ')}>
        <span className="tpo-field__label">{t('productTemplate.colStyleNo')}</span>
        <input
          className="tpo-input"
          value={value}
          disabled={disabled}
          placeholder={t('productTemplate.styleNoPh')}
          onChange={(e) => onChange?.(e.target.value)}
          onKeyDown={(e) => {
            if (e.key === 'Enter') onEnter?.();
          }}
        />
        <button
          type="button"
          className="tpo-batch-add-btn"
          disabled={disabled}
          aria-label={t('productTemplate.batchStyleAria')}
          title={t('returnList.batchQuery')}
          onClick={() => setBatchOpen(true)}
        >
          <Plus size={16} strokeWidth={2.25} aria-hidden="true" />
        </button>
      </div>
      <BatchQueryModal
        open={batchOpen}
        title={t('productTemplate.batchStyleTitle')}
        initialValue={value}
        placeholder={t('productTemplate.batchStylePh', { count: BATCH_QUERY_LIMIT })}
        onClose={() => setBatchOpen(false)}
        onConfirm={(tokens) => {
          onChange?.(joinBatchTokens(tokens.slice(0, BATCH_QUERY_LIMIT)));
        }}
      />
    </>
  );
}
